import { NavDropdown } from "./Components";
import { A } from "@solidjs/router";

export default function Admin() { return null; }

export const AdminMenu = () => {
  return (
    <NavDropdown label="Admin">
      <li><A class="dropdown-item" href="/manage-users">Manage Users</A></li>
    </NavDropdown>
  );
};